// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"60a1e29d","239":"e39fb35b","298":"ec05332f","355":"1fd05948","455":"7393c6d3","857":"44f4b707","977":"97c88509"}[chunkId] + ".chunk.js";
};